// extracted by mini-css-extract-plugin
export default {"wrap":"NotFound_wrap__LwYBH","title":"NotFound_title__wLwBY","text":"NotFound_text__73Ril","link":"NotFound_link__m+ohG"};